import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(
  () =>
    createStyles({
      root: {},
    }),
  { name: 'FormControlLabel' }
);
